// utils/device.js
export const isTouchDevice = () => {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  };
  
  export const isMobileOrTablet = () => {
    const width = window.innerWidth;
    return isTouchDevice() || width <= 1024; // Catch touchscreens and narrow screens
  };
  